import { useEffect, useState } from "react";
import { AlertTriangle, Loader2, Clock, CheckCircle2 } from "lucide-react";
import { useLang } from "../../lib/i18n";

export const statusText = (job, t) =>
  job.status === "chunk" && job.progress ? t("st_chunk", { c: job.progress.current, t: job.progress.total }) : t(`st_${job.status}`);

const fmtDur = (s, t) => (s >= 60 ? `${Math.ceil(s / 60)} ${t("min")}` : `${Math.max(1, Math.round(s))} ${t("sec")}`);

const useNow = (active) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [active]);
  return now;
};

export const JobProgress = ({ job, isVideo }) => {
  const { t, te } = useLang();
  const active = ["queued", "running", "chunk"].includes(job.status);
  const now = useNow(active);
  const start = new Date(job.started_at || job.created_at).getTime();
  const elapsed = (now - start) / 1000;
  const remaining = (job.estimate_s || 60) - elapsed;
  const pct = Math.min(96, Math.max(4, (elapsed / (job.estimate_s || 60)) * 100));
  const Icon = job.status === "error" ? AlertTriangle : job.status === "done" ? CheckCircle2 : job.status === "queued" ? Clock : Loader2;
  return (
    <div className={`frz-job is-${job.status}`} data-testid="job-progress-card">
      <div className="frz-job-row">
        <Icon size={16} className={active && job.status !== "queued" ? "spin" : ""} />
        <span className="frz-job-label">{job.label || t(`op_${job.type}`)}</span>
        <span className="frz-job-status" data-testid="job-status-text">{statusText(job, t)}</span>
      </div>
      {active && (
        <>
          <div className="frz-bar"><span style={{ width: `${pct}%` }} /></div>
          <p className="frz-job-eta" data-testid="job-eta">{remaining > 5 ? t("eta", { t: fmtDur(remaining, t) }) : t("eta_soon")}</p>
          {isVideo && <p className="frz-job-note" data-testid="job-close-note">{t("close_note")}</p>}
        </>
      )}
      {job.status === "error" && <p className="frz-error" data-testid="job-error-text">{te(job.error)}</p>}
    </div>
  );
};
